(function ($, Drupal, once) {
  Drupal.behaviors.mySwipers = {
    attach: function (context) {

      const configs = [
        {
          selector: '.field--name-field-header-media.swiper',
          options: {
            speed: 1200,
            slidesPerView: 1,
            spaceBetween: 0,
            grabCursor: true,
            watchOverflow: true,
            pagination: {
              el: ".pagination-headermedia",
              clickable: true,
            },
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            },
            breakpoints: {
              768: { slidesPerView: 1, spaceBetween: 0 },
            }
          },
          maxWidth: false // Swiper nur unterhalb dieser Breite
        }
      ];




      configs.forEach(cfg => {
        once('swiper-init', cfg.selector, context).forEach((el) => {
          let swiper = null;
          const mql = cfg.maxWidth !== false
            ? window.matchMedia(`(max-width: ${cfg.maxWidth}px)`)
            : null;

          const toggleNav = (show) => {
            ['.swiper-pagination', '.swiper-button-next', '.swiper-button-prev'].forEach(sel => {
              const node = el.querySelector(sel);
              if (node) node.classList.toggle('hidden', !show);
            });
          };

          const cleanupStyles = () => {
            el.querySelectorAll('.swiper, .swiper-wrapper, .swiper-slide').forEach(node => {
              node.removeAttribute('style');
              node.classList.remove('swiper-initialized', 'swiper-horizontal');
            });
          };

          const toggle = () => {
            const shouldInit = cfg.maxWidth === false || (mql && mql.matches);

            if (shouldInit) {
              if (!swiper) {
                toggleNav(true);
                swiper = new Swiper(el, cfg.options);
              }
            } else {
              if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
              }
              toggleNav(false);
              cleanupStyles();
            }
          };

          toggle();
          if (mql) {
            mql.addEventListener
              ? mql.addEventListener('change', toggle)
              : mql.addListener(toggle);
          }
        });
      });

    }
  };
})(jQuery, Drupal, once);
